<div class="ui-graph" [class.dark]="theme() === 'dark'">
	<ngx-charts-pie-chart
		hotfix-zero-margin
		[view]="view()"
		[scheme]="colorsDomain()"
		[results]="singleSeries()"
		[gradient]="gradient()"
		[legend]="showLegend()"
		[legendPosition]="legendPositionCalculated()"
		[labels]="showLabels()"
		[maxLabelLength]="60"
		[doughnut]="isDoughnut()"
		[tooltipDisabled]="tooltipDisabled"
	>
	</ngx-charts-pie-chart>
</div>
